import React from 'react';
import ChowaDashboardLayout from './config/ChowaDashboardLayout';
import { sidebarConfig } from './config/sidebarConfig';
import { ChowaThemeProvider } from './config/chowaThemeContext';
import ChowaMainDashboard from './dashboard/main/ChowaMainDashboard';
import TimeMonitoringSeriesSelection from './time-monitoring/TimeMonitoringSeriesSelection';
import HVSeriesPage from './time-monitoring/HVSeriesPage';
import SRSeriesPage from './time-monitoring/SRSeriesPage';
import ZVSeriesPage from './time-monitoring/ZVSeriesPage';
import OldTMS000 from './TMS000/TMS000';  // 旧TMS000
import NewTMS000 from './TMS/TMS000/TMS000';  // 新TMS000

const routes = [
  // ダッシュボード（独立）
  {
    path: 'main',
    component: ChowaMainDashboard
  },
  // 時間監視のルート
  {
    path: 'time-monitoring',
    component: TimeMonitoringSeriesSelection
  },
  {
    path: 'time-monitoring/hv',
    component: HVSeriesPage
  },
  {
    path: 'time-monitoring/sr',
    component: SRSeriesPage
  },
  {
    path: 'time-monitoring/zv',
    component: ZVSeriesPage
  },
  // TMSのルート
  {
    path: 'tms/old_tms/*',  // 旧TMS000のパス
    component: OldTMS000
  },
  {
    path: 'tms/tms000/*',  // 新TMS000のパス
    component: NewTMS000
  }
];

const ChowaApp = () => {
  return (
    <ChowaThemeProvider>
      <div data-chowa-app>
        <ChowaDashboardLayout 
          routes={routes} 
          sidebarConfig={sidebarConfig}
        />
      </div>
    </ChowaThemeProvider>
  );
};

export default ChowaApp; 